import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const accountUnlock = http.patch(
  createMockEndpoint('/account/:id/unlock'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
